import type { MetaFunction } from "@remix-run/node"
import { keyframes } from "@emotion/react"
import { Box, Text, Center, Link, Heading, HStack } from "@chakra-ui/react"
import {Link as RouterLink} from 'react-router-dom'
import { motion } from 'framer-motion';
import Logo from '~/components/Logo/'
import { FacebookProfile, InstagramProfile } from "~/components/SocialMediaButtons";
import {isRouteErrorResponse } from '@remix-run/react' 

export const meta: MetaFunction = () => {
  return [
    { title: "Wydawnictwo Dystans" },
    { name: "description", content: "Nie znaleziono strony." },
    {
      name: 'robots',
      content: "noindex, nofollow"
    }
  ];
};

const animationKeyframes = keyframes`
  0% { transform: scale(1)}
  50% { transform: scale(1.06) }
  100% { transform: scale(1) }
`;

const animation = `${animationKeyframes} 30s linear infinite`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Page404 ({error}: {error: any}) {
  const errorMessage = isRouteErrorResponse(error)
            ? `${error.status} ${error.statusText}`
            : error instanceof Error
            ? error.message
            : "Unknown Error"
  return (
    <Box overflow={'hidden'} height={'100%'} textAlign={'center'}>
      <Logo width={220} logoColor={'orange'} />
      <Heading my={16} size={'3xl'}>{errorMessage}</Heading>
      <Link to={'/'} fontSize={24} textDecoration={'underline'} my={12} as={RouterLink}>Strona główna</Link>
      <Center my={24}>
      <HStack>
        <FacebookProfile size={32} />
        <InstagramProfile size={32} />
        </HStack>
      </Center>
      <Text decoration={'underline'}>
        photos @ <Link isExternal href="https://szymon.bike">szymonbike</Link>
      </Text>
      <Text>
        Copyright @ Wydawnictwo Dystans. 2024.
      </Text>
      
      <Box sx={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          position: 'absolute',
          top: 0,
          zIndex: -1
        }}>
        <Box p={0} m={0}  as={motion.div} animation={animation} sx={{
          width: '100%',
          height: '100%',
          backgroundPosition: '50% 50%',
          backgroundSize: 'cover', 
          backgroundImage: '/images/background_lg.webp'
        }} />
      </Box>
    </Box>

  );
}